import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

// ----------------------------------------------------------------------

/**
 * Center-of-screen status while the open report's data is being captured for the AI
 * assistant (JS9 CSV/PDF export, then the S3 archival upload). Deliberately not a modal:
 * no backdrop, and `pointerEvents: 'none'` so it never intercepts clicks — the user can
 * still navigate away via the nav menu while this is showing.
 *
 * @param {{ exporting?: boolean, saving?: boolean }} props
 */
export function ReportContextStatusOverlay({ exporting = false, saving = false }) {
  if (!exporting && !saving) return null;

  const label = exporting ? 'Exporting report data...' : 'Saving report data...';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1400,
        pointerEvents: 'none',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{
          px: 2.5,
          py: 1.5,
          borderRadius: 2,
          bgcolor: 'background.paper',
          border: (theme) => `1px solid ${theme.palette.divider}`,
          boxShadow: (theme) => theme.shadows[20],
        }}
      >
        <CircularProgress size={18} color="primary" />
        <Typography variant="body2" sx={{ color: 'text.primary' }}>
          {label}
        </Typography>
      </Stack>
    </Box>
  );
}
